import Amplify from "aws-amplify";

export default function iniciarConfiguracionAPI() {
  let headers = {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_API_KEY,
  };

  let headersVitalicias = {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_VITALICIAS_API_KEY,
  };

  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: process.env.REACT_APP_REGION,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_APP_CLIENT_ID,
      oauth: {
        domain: process.env.REACT_APP_USER_POOL_DOMAIN_NAME,
        redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
        redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
        responseType: process.env.REACT_APP_OAUTH_RESPONSE_TYPE,
        scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"], //'phone',
      },
    },
    API: {
      endpoints: [
        {
          name: process.env.REACT_APP_ENDPOINT_NAME,
          endpoint: process.env.REACT_APP_URL_API,
          region: process.env.REACT_APP_REGION_END_POINT,
          custom_header: async () => {
            return headers;
          },
        },
        {
          name: process.env.REACT_APP_END_POINT_NAME_CLIENT,
          endpoint: process.env.REACT_APP_URL_API_SERVICE_CLIENT,
          region: process.env.REACT_APP_REGION_END_POINT_SERVICE_CLIENT,
          custom_header: async () => {
            return headers;
          },
        },
        {
          name: process.env.REACT_APP_ENDPOINT_NAME_CONTROL_TOWER,
          endpoint: process.env.REACT_APP_URL_API_CONTROL_TOWER,
          region: process.env.REACT_APP_REGION_END_POINT,
          custom_header: async () => {
            return headers;
          },
        },
        {
          name: process.env.REACT_APP_ENDPOINT_NAME_EXTRA_OFICIALES,
          endpoint:
            process.env.REACT_APP_URL_API_EXTRA_OFICIALES,
          region: process.env.REACT_APP_REGION_END_POINT,
          custom_header: async () => {
            return headers;
          },
        },
        {
          name: process.env.REACT_APP_ENDPOINT_VITALICIAS_NAME,
          endpoint: process.env.REACT_APP_URL_VITALICIAS_API,
          region: process.env.REACT_APP_REGION_VITALICIAS_END_POINT,
          custom_header: async () => {
            return headersVitalicias;
          },
        },
      ],
    },
  });
}
